import React from 'react';
import { useSelector } from 'react-redux';
import { selectedClientSelector } from '../../store/slices/selectedClient';
import { Menu } from 'lucide-react';
import { useSidebar } from '../../contexts/SidebarContext';
import { Button } from '../../components/ui/button';

const LocalRankTracker = () => {
  const { selectedClient } = useSelector(selectedClientSelector);
  const { sidebarOpen, setSidebarOpen } = useSidebar();
  return (
    <>
      {/* Top Bar */}
      <header className="sticky top-0 z-10 bg-card">
        <div className="px-10 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            {!sidebarOpen && (
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setSidebarOpen(true)}
                className="h-10 w-10 border-0 hover:bg-gray-100/80"
                style={{
                  borderRadius: '8px',
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  backdropFilter: 'blur(8px)',
                  boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)'
                }}>
                <Menu className="h-5 w-5" style={{ color: '#3766a8' }} />
              </Button>
            )}
            <div style={{ marginBottom: '0' }}>
              <h1
                className="text-xl font-semibold"
                style={{ marginBottom: '0.25rem' }}>
                Local Rank Tracker
              </h1>
              <p
                className="text-sm text-muted-foreground"
                style={{ marginBottom: '0' }}>
                Track your local search rankings and visibility
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Content Area */}
      <div className="p-6">{/* Content will be added here */}</div>
    </>
  );
};

export default LocalRankTracker;
